import React from "react";

interface RadialGradientProps {
  colors: {
    start: string;
    middle?: string;
    end: string;
  };
  positions?: {
    start?: string;
    middle?: string;
    end?: string;
  };
  className?: string;
  children?: React.ReactNode;
  centerPosition?: string;
  blur?: boolean;
}

export function RadialGradientBackground({
  colors,
  positions = {},
  className = "",
  children,
  centerPosition = "50% 50%",
  blur = false,
}: RadialGradientProps) {
  const getGradientStyle = () => {
    const startPos = positions.start || "0%";
    const middlePos = positions.middle || "40%";
    const endPos = positions.end || "100%";

    let gradient = `radial-gradient(circle at ${centerPosition}, `;

    gradient += `${colors.start} ${startPos}`;

    if (colors.middle) {
      gradient += `, ${colors.middle} ${middlePos}`;
    }

    gradient += `, ${colors.end} ${endPos})`;

    return gradient;
  };

  return (
    <div
      className={`relative ${className}`}
      style={{
        background: getGradientStyle(),
      }}
    >
      {blur && (
        <div className="absolute inset-0 backdrop-blur-sm pointer-events-none" />
      )}
      {children}
    </div>
  );
}

export function WestSideGradient({
  className = "",
  children,
}: {
  className?: string;
  children?: React.ReactNode;
}) {
  return (
    <RadialGradientBackground
      colors={{
        start: "rgb(236, 72, 153)",
        middle: "rgb(59, 130, 246)",
        end: "rgb(0, 0, 0)",
      }}
      positions={{
        start: "0%",
        middle: "40%",
        end: "100%",
      }}
      className={className}
    >
      {children}
    </RadialGradientBackground>
  );
}

export const gradientPresets = {
  westSide: {
    colors: {
      start: "rgb(236, 72, 153)",
      middle: "rgb(59, 130, 246)",
      end: "rgb(0, 0, 0)",
    },
    positions: {
      start: "0%",
      middle: "40%",
      end: "100%",
    },
  },
  sunset: {
    colors: {
      start: "#ff5e26",
      middle: "#ffa500",
      end: "#29333c",
    },
    positions: {
      start: "0%",
      middle: "50%",
      end: "100%",
    },
  },
  ocean: {
    colors: {
      start: "#00d4ff",
      middle: "#0066cc",
      end: "#001f3f",
    },
    positions: {
      start: "0%",
      middle: "45%",
      end: "100%",
    },
  },
  neon: {
    colors: {
      start: "#ff00ff",
      middle: "#00ffff",
      end: "#000000",
    },
    positions: {
      start: "0%",
      middle: "50%",
      end: "100%",
    },
  },
};
